import api from '@/api'

const SET_INGREDIENT_TYPES = 'SET_INGREDIENT_TYPES'
const ADD_INGREDIENT_TYPE = 'ADD_INGREDIENT_TYPE'

const SET_DEFAULT_INGREDIENT_TYPES = 'SET_DEFAULT_INGREDIENT_TYPES'

const SET_INGREDIENT_TYPE = 'SET_INGREDIENT_TYPE'
const UNSET_INGREDIENT_TYPE = 'UNSET_INGREDIENT_TYPE'

const SET_COUNT = 'SET_COUNT'

export default {
  namespaced: true,

  state () {
    return {
      ingredientTypes: [],
      ingredientTypesList: [],
      defaultIngredientTypes: [],
      currentIngredientType: null,
      count: 0
    }
  },

  getters: {
    ingredientTypes: (state) => state.ingredientTypes,
    ingredientTypesList: (state) => state.ingredientTypesList,
    defaultIngredientTypes: (state) => state.defaultIngredientTypes,
    currentIngredientType: (state) => state.currentIngredientType,
    count: (state) => state.count
  },

  mutations: {
    [SET_INGREDIENT_TYPES] (state, data) {
      state.ingredientTypes = data
    },

    [SET_DEFAULT_INGREDIENT_TYPES] (state, data) {
      state.defaultIngredientTypes = data
    },

    [ADD_INGREDIENT_TYPE] (state, data) {
      state.ingredientTypes.shift(data)
    },

    [SET_INGREDIENT_TYPE] (state, data) {
      state.currentIngredientType = data
    },

    [UNSET_INGREDIENT_TYPE] (state) {
      state.currentIngredientType = null
    },

    [SET_COUNT] (state, count) {
      state.count = count
    }
  },

  actions: {
    async loadIngredientTypes ({ commit }, params = {}) {
      const { data, count } = await api.ingredienttypes.list(params)
      commit(SET_INGREDIENT_TYPES, data || [])
      commit(SET_COUNT, count || 0)
      return { data, count }
    },

    async loadDefaultIngredientTypes ({ commit }) {
      try {
        const { data } = await api.ingredienttypes.default()
        commit(SET_DEFAULT_INGREDIENT_TYPES, data || [])
        return data
      } catch (error) {
        console.error('Failed to load default ingredient types:', error)
        return []
      }
    },

    async createIngredientType ({ dispatch }, payload) {
      const { error } = await api.ingredienttypes.create(payload)
      return error
    },

    async selectIngredientType ({ commit }, id) {
      const { data } = await api.ingredienttypes.getById(id)
      commit(SET_INGREDIENT_TYPE, data)
      return data
    },

    async updateIngredientType ({ commit, getters }) {
      const item = getters.currentIngredientType
      const { error } = await api.ingredienttypes.updateById(item.id, item)

      if (!error) {
        commit(UNSET_INGREDIENT_TYPE)
      }

      return error
    },

    async deleteIngredientType ({ commit, getters }) {
      const item = getters.currentIngredientType
      await api.ingredienttypes.deleteById(item.id)
      commit(UNSET_INGREDIENT_TYPE)
    },

    closeIngredientType ({ commit }) {
      commit(UNSET_INGREDIENT_TYPE)
    }
  }
}
